import React from 'react';
import type { SessionHydration_Asset_Image } from '~/graphql/types';
import MissingAssetPlaceholder from '../MissingAssetPlaceholder';
import ImageCard from '~/components/atom/ImageCard';
import { isNil } from 'ramda';

type Props = {
  asset: SessionHydration_Asset_Image | null;
  currentAssetId: string | null;
  initialAssetId: string | null;
  onChangeAssetId: ({ assetId }: { assetId: string }) => void;
};

/**
 * Displays the selected asset card or the missing asset placeholder if the asset is deleted
 */
const InitialAssetCard: React.FCC<Props> = ({
  asset,
  onChangeAssetId,
  currentAssetId,
  initialAssetId,
}) => {
  if (!initialAssetId) return null;

  const anotherAssetSelected =
    currentAssetId !== initialAssetId && !isNil(currentAssetId);
  const assetDeleted = isNil(asset);

  if (assetDeleted) {
    if (anotherAssetSelected) return null;
    return <MissingAssetPlaceholder />;
  }

  return (
    <ImageCard
      onClick={() => onChangeAssetId({ assetId: asset.id })}
      selected={currentAssetId === asset.id}
      src={asset.url}
      label={asset.label}
    />
  );
};

export default InitialAssetCard;
